import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AdminConsole } from "./components/AdminConsole";
import "./styles.css";
import "./appearance.css";
import { applyAppearance } from "./appearance";
import { readPreferences } from "./usePreferences";

applyAppearance(readPreferences());

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		{window.location.pathname === "/admin" ? <AdminConsole /> : <App />}
	</StrictMode>,
);

// Registered in development as well: saving an alert waits on the worker being ready, so
// without it the whole flow is untestable locally. It declines to cache anything there.
if ("serviceWorker" in navigator) {
	window.addEventListener("load", () => {
		void navigator.serviceWorker.register("/sw.js");
	});
}
